import UserList from '../components/user/List'
import UserCreate from '../components/user/Create'
import UserUpdate from '../components/user/Update'

export default [
  {
    name: 'User',
    path: '/users/',
    component: {template: '<router-view></router-view>'},
    redirect: {name: 'UserList'},
    children: [
      {name: 'UserList', path: '', component: UserList},
      {name: 'UserCreate', path: 'create', component: UserCreate},
      {name: 'UserUpdate', path: 'edit/:id', component: UserUpdate}
    ]
  }
]
